import { LazyAsyncOnceClass } from '@zaoblako/shared/common/classes/lazy-async-once.class';
import { openDB, type IDBPDatabase, type DBSchema, type OpenDBCallbacks } from 'idb';

import { Injectable } from '@angular/core';

/** Wrapper for "IndexedDB" */
@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {
  private readonly databases: Record<string, LazyAsyncOnceClass<IDBPDatabase<any>>> = {};

  /**
   * Open "IndexedDB" database
   *
   * @param dbName Database name
   * @param dbVersion Database version (positive integer)
   * @param [callbacks] Database event handlers
   *
   * @returns `Promise` with database connector
   */
  public getDatabase<T extends DBSchema = any>(
    dbName: string,
    dbVersion: number,
    callbacks?: OpenDBCallbacks<T>
  ): Promise<IDBPDatabase<T>> {
    if (!this.databases[dbName]) {
      this.databases[dbName] = new LazyAsyncOnceClass(() => openDB(dbName, dbVersion, callbacks));
    }
    return this.databases[dbName].getValue();
  }
}
